class PasswordDrawer extends HTMLElement {
  constructor() {
    super();
    this.drawer = this.querySelector('#PasswordDrawer');
    this.overlay = this.querySelector('#PasswordDrawer-Overlay');
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.overlay.addEventListener('click', this.close.bind(this));
    this.querySelector('#PasswordDrawer-close').addEventListener('click', this.close.bind(this));
    document.querySelector('#PasswordDrawer-Open').addEventListener('click', this.open.bind(this));
  }

  connectedCallback() {
    const hasError = this.querySelector('#PasswordError');
    if(hasError) {
      this.open();
    }
  }

  open() {
    this.drawer.style.transform = 'translateX(0)';
    this.overlay.classList.remove('invisible');
    this.overlay.classList.remove('pointer-events-none');
    this.overlay.classList.remove('opacity-0');

    this.drawer.addEventListener('transitionend', () => {
      
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.drawer.style.transform = 'translateX(100%)';
    document.body.classList.remove('overflow-hidden');
    this.overlay.classList.add('invisible');
    this.overlay.classList.add('pointer-events-none');
    this.overlay.classList.add('opacity-0');
  }
}

customElements.define('password-drawer', PasswordDrawer);